export default "__VITE_ASSET__Bl9eRJFy__"